import { I18nextProvider } from "react-i18next"
import React from "react"
import i18next from "../i18n/config"

type WrapPageProps = {
    children: React.ReactNode
}

const WrapPage = ({ children }: WrapPageProps) => {
    return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
}

export default WrapPage
